// extracted by mini-css-extract-plugin
export default {"PlanHeader":"PlanHeader_PlanHeader__e2sPm","scrollBackground":"PlanHeader_scrollBackground__0fiOP"};